// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_IDi","comment":"styles_comment__oNu4I"};